/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ClearanceCaseStatus {
  Cancelled = -1,
  Created = 0,
  Registered = 1,
  FirstLineProcessing = 10,
  FirstLineWaitingForCustomer = 11,
  ReadyForProcessing = 20,
  Processing = 21,
  WaitingForCustomer = 22,
  Processed = 23,
  ProcessedAwaitingCustoms = 30,
  ProcessedAcceptedClearing = 31,
  ProcessedFailedClearing = 32,
  ProcessedCleared = 33,
  Completed = 40,
}
